// (function() {
//   const BREAKPOINT = 900; // Change to whatever width you want the switch to happen at
//   let isUpdating = false;
  
//   function applyMenuStyle() {
//     const header = document.getElementById('header-component');
//     if (!header) return;
    
//     const desired = window.innerWidth >= BREAKPOINT ? 'menu' : 'drawer';
//     const current = header.getAttribute('data-menu-style');
    
//     if (current !== desired) {
//       isUpdating = true;
//       header.setAttribute('data-menu-style', desired);
//       setTimeout(function() { isUpdating = false; }, 100);
//     }
//   }
  
//   function init() {
//     applyMenuStyle();
    
//     // Re-run on resize (debounced)
//     let resizeTimer;
//     window.addEventListener('resize', function() {
//       clearTimeout(resizeTimer);
//       resizeTimer = setTimeout(applyMenuStyle, 80);
//     });
    
//     // Fight back if Horizon's JS changes the attribute
//     const header = document.getElementById('header-component');
//     if (header && window.MutationObserver) {
//       const observer = new MutationObserver(function(mutations) {
//         if (isUpdating) return;
//         for (let i = 0; i < mutations.length; i++) {
//           if (mutations[i].attributeName === 'data-menu-style') {
//             applyMenuStyle();
//             break;
//           }
//         }
//       });
//       observer.observe(header, {
//         attributes: true,
//         attributeFilter: ['data-menu-style']
//       });
//     }
//   }
  
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
  
//   // Also run after a short delay to catch Horizon's late initialization
//   setTimeout(applyMenuStyle, 500);
//   setTimeout(applyMenuStyle, 1500);
// })();

(function () {
  const BREAKPOINT = 1250;

  function applyMenuStyle() {
    const header = document.getElementById('header-component');
    if (!header) return;
    const desired = window.innerWidth >= BREAKPOINT ? 'menu' : 'drawer';
    if (header.getAttribute('data-menu-style') !== desired) {
      header.setAttribute('data-menu-style', desired);
    }
  }

  function init() {
    applyMenuStyle();

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyMenuStyle, 80);
    });

    const header = document.getElementById('header-component');
    if (header && window.MutationObserver) {
      new MutationObserver(applyMenuStyle).observe(header, {
        attributes: true,
        attributeFilter: ['data-menu-style'],
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();